import { MARQUEE_ITEMS } from "./content";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="group border-y border-zinc-200 bg-white py-5 overflow-hidden" aria-hidden="true">
      <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
        {items.map((item, i) => (
          <span
            key={i}
            className="flex items-center text-sm font-medium text-zinc-500 whitespace-nowrap"
          >
            <span className="px-6">{item}</span>
            <span className="h-1 w-1 rounded-full bg-zinc-300" />
          </span>
        ))}
      </div>
    </div>
  );
}
